export default "__VITE_ASSET__CRP7pT94__"